export default __webpack_public_path__ + "assets/images/illustration.4b1bbac1e04c702c48aa3a30a2113f8c.svg";